module.exports = __webpack_public_path__ + "static/media/GooglePlay.4cb26e06.png";